<template>
  <div
    class="ct-report-bottom"
    :class="{ 'ct-guide-download-zone': highlightDownload }"
  >
    <div class="ct-report-copy">
      <strong>{{ title }}</strong>
      <span>{{ subtitle }}</span>
      <ul
        v-if="integrated && includedTests.length > 1"
        class="ct-report-included"
      >
        <li v-for="entry in includedTests" :key="entry.testValue">
          {{ entry.label }}
        </li>
      </ul>
    </div>
    <button
      ref="downloadBtn"
      type="button"
      class="ct-direct-btn"
      :class="{ 'ct-guide-download': highlightDownload }"
      :disabled="!canDownload || downloading"
      @click="download"
    >
      {{ downloading ? "Generando…" : downloadLabel }}
    </button>
  </div>
</template>

<script>
import testService from "@/services/testService";
import { formatReportDownloadError } from "../utils/reportDownloadError";
import { normalizeTestIds } from "../utils/normalizeTestIds";

export default {
  name: "ReportBottom",
  props: {
    title: { type: String, default: "Informe listo para Word" },
    subtitle: { type: String, default: "" },
    testIds: { type: Array, default: () => [] },
    includedTests: { type: Array, default: () => [] },
    canDownload: { type: Boolean, default: false },
    highlightDownload: { type: Boolean, default: false },
    integrated: { type: Boolean, default: false },
    reportMode: { type: String, default: "individual" },
    session: { type: Object, default: null },
  },
  data() {
    return { downloading: false };
  },
  computed: {
    downloadLabel() {
      if (this.integrated) return "Descargar informe integrado";
      return "Descargar informe Word";
    },
  },
  methods: {
    getDownloadButtonEl() {
      return this.$refs.downloadBtn;
    },
    download() {
      const ids = normalizeTestIds(this.testIds);
      if (!ids.length || this.downloading) return;
      this.downloading = true;
      // El modo lo decide el workspace según la sesión: logueado -> "combined"
      // (Word integrado); anónimo -> "individual" (solo el test recién hecho).
      testService
        .correctedTestsReport({ test_ids: ids, report_mode: this.reportMode })
        .then((response) => {
          let filename = "Informe_Tests.docx";
          const disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
              disposition
            );
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          const link = document.createElement("a");
          const objectUrl = window.URL.createObjectURL(blob);
          link.href = objectUrl;
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(objectUrl);
          if (this.session) {
            ids.forEach((id) => this.session.markDownloaded(id));
          }
          this.$emit("downloaded");
        })
        .catch(async (error) => {
          const msg = await formatReportDownloadError(error);
          if (this.$toasted) {
            this.$toasted.error("Error al generar el reporte: " + msg);
          }
        })
        .finally(() => {
          this.downloading = false;
        });
    },
  },
};
</script>
